import { ApiMethods } from '@/features/api.methods';
import { ApiServiceInstance } from '@/features/api.service';
import { ApiUrls } from '@/features/apiUrls';
import { LoginRequest } from '@/models/auth/LoginRequest';
import { LoginResponse } from '@/models/auth/LoginResponse';
import router from '@/router/index';
import { removeUserData, setUserData } from '@/utils/localStorage';
import { useCookies } from 'vue3-cookies';

const { cookies } = useCookies();

const setToken = (token: string | undefined) => {
    if (!token) {
        console.error('Cannot set undefined token');
        return;
    }
    cookies.set('token', token);
};

export class AuthService {
    private async refreshToken() {
        return true;
    }

    public async login(model: LoginRequest) {
        let result = await ApiServiceInstance.sendRequest<LoginResponse>(ApiMethods.POST, ApiUrls.LOGIN_URL, model);
        if (result && result.successResult) {
            setToken(result.successResult?.token);
            localStorage.setItem('user', JSON.stringify(result.successResult?.user));
            localStorage.setItem('role', JSON.stringify(result.successResult?.user.role));
            setUserData(result.successResult?.user);
            await router.push({ name: 'home' });
            window.location.reload();
        }
    }

    public async logout(): Promise<void> {
        cookies.remove('token');
        localStorage.removeItem('user');
        localStorage.removeItem('role');
        removeUserData();
        await router.push({ name: 'login' });
    }
}

export const authServiceInstance = new AuthService();